import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import IconButton from "@material-ui/core/IconButton"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import PlaceIcon from "@material-ui/icons/Place"
import { useContext, useEffect, useRef, useState } from "react"
import SiteContext from "../../contexts/SiteContext"

import { ComumCep, RegistrarLogErro } from "../../services/functions"

import { Loader } from "@googlemaps/js-api-loader"
import { AddressMinimap } from "@mapbox/search-js-react"
import { DialogActions, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core"
import useParametros from "../../contexts/ParametrosContext"
import { useTextos } from "../../contexts/TextosContext"
import api from "../../services/api"

const useStyles = makeStyles(theme => ({
    dialogContent: {
        textAlign: "center",
    },
    contentContainer: {
        width: "80%",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        alignItems: "center",
        justifyContent: "center",
        margin: "2rem auto 0 auto",
        [theme.breakpoints.down("sm")]: {
            width: "85%",
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
        },
    },
    mapContainer: {
        width: "100%",
        aspectRatio: "16/7",
        overflow: "hidden",
        "& > div": { height: "100%" },
        [theme.breakpoints.down("sm")]: {
            aspectRatio: "2/1",
        },
        [theme.breakpoints.down("xs")]: {
            aspectRatio: "4/3",
        },
    },
    googleMapsContainer: {
        width: "100%",
        aspectRatio: "12/5",
        "& > div": { height: "100%" },
        [theme.breakpoints.down("sm")]: {
            aspectRatio: "2/1",
        },
        [theme.breakpoints.down("xs")]: {
            aspectRatio: "4/3",
        },
    },
    buttonContainer: {
        display: "flex",
        width: "100%",
        gap: "clamp(0.5rem, 5%, 1rem)",
        "& > button": {
            flex: 1,
        },
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
        },
    },
    confirmarButton: {
        backgroundColor: `#28a745`,
        color: "white",
        "&:hover": {
            backgroundColor: "#28a745",
            filter: "brightness(1.05)",
        },
    },
    featureOptionList: {
        marginBottom: "1rem",
        "& svg": { marginRight: "0.5rem" },
        "& > div > div": {
            overflow: "hidden",
        },
    },
    featureOption: {
        display: "flex",
        gap: "0.5rem",
        alignItems: "center",
        fontSize: "1rem",
        "& > svg": {
            fontSize: "1.5rem",
        },
    },
}))

// TODO: Remover
const keyMapBox =
    "pk.eyJ1IjoiY2xpZW50ZWZpZWwiLCJhIjoiY2xzbmFrMjNiMDI1dDJpbnNvdm00enQ3aiJ9.gj6zNfUXE5F-SkpKDh-Ing"
const keyGoogleMaps = "AIzaSyAr6pWr6cj7IZ931BnL84KgCiYinmmf35A"

const DialogConfirmationMapBox = props => {
    const classes = useStyles()
    const textos = useTextos()

    return (
        <Dialog
            open={props.openConfirmationMap}
            onClose={props.handleCloseConfirmationMap}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <IconButton className="setaVoltarModal" onClick={props.handleCloseConfirmationMap}>
                    <ArrowForwardIosIcon />
                </IconButton>
                {textos.confirmarEndereco}
            </DialogTitle>
            <DialogContent style={{ padding: "1rem" }}>
                {props.selectedFeature && (
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Opções de Endereço</InputLabel>
                        <Select
                            value={props.selectedFeature}
                            onChange={props.handleChangeFeature}
                            className={classes.featureOptionList}
                            label="Opções de Endereço"
                        >
                            {props.featureOptions.map(feature => (
                                <MenuItem divider value={feature} className={classes.featureOption}>
                                    <PlaceIcon />
                                    {feature.place_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                <div className={classes.mapContainer}>
                    <AddressMinimap
                        show={props.openConfirmationMap}
                        canAdjustMarker={true}
                        feature={props.selectedFeature}
                        onSaveMarkerLocation={props.handleSaveMarkerLocation}
                        accessToken={keyMapBox}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttonContainer}>
                    <Button variant="contained" onClick={props.handleCloseConfirmationMap}>
                        {textos.cancelar}
                    </Button>
                    <Button
                        className={classes.confirmarButton}
                        variant="contained"
                        onClick={props.checarCepMapBox}
                    >
                        {textos.confirmar}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    )
}

export default function DialogCEP(props) {
    const {
        aplicativoDados,
        setAplicativoDados,

        estabelecimentoAtual,

        loading,
        setLoading,
    } = useContext(SiteContext)

    const textos = useTextos()

    const {
        abrirCEP,
        setAbrirCEP,

        abrirNovoEndereco,
        setAbrirNovoEndereco,

        setCepFoiCadastrado,

        alertStart,

        setEnderecoCadastrado,

        selecioneiRetiradaNoLocal,

        DialogConfirmacaoinformacoes,

        DialogFormaDePagamento,
    } = props

    const classes = useStyles()

    const parametros = useParametros()

    const usarGoogleMapsAPI = aplicativoDados.tipoSelecaoEndereco === 1
    const usarMapBoxAPI = aplicativoDados.tipoSelecaoEndereco === 2
    const usarAlgumMapa = usarGoogleMapsAPI || usarMapBoxAPI

    const googleMapRef = useRef(null)
    const listenerRef = useRef(null)
    const markerRef = useRef(null)
    const placeRef = useRef(null)

    const [loader] = useState(
        new Loader({
            apiKey: keyGoogleMaps,
            version: "beta",
            libraries: ["places"],
        })
    )

    const checarCepGoogleMaps = async endereco => {
        try {
            let valorCep = endereco.address_components
                .find(addressComponent => addressComponent.types.includes("postal_code"))
                ?.long_name.replace(/-/g, "")
                .replace(/ /g, "")
                .replace(/\//g, "")

            if (valorCep?.length === 8) {
                setLoading(true)
                const response = await ComumCep(valorCep, aplicativoDados)

                if (response.retornoErro) {
                    setLoading(false)
                    alertStart(response.mensagem, "error")
                    return
                }

                if (response.bairroEspecifico || response.bairros?.length >= 1) {
                    setEnderecoCadastrado({
                        ...response,
                        bairroEspecifico: true,
                        cep: valorCep,
                        logradouro: endereco.address_components.find(addressComponent =>
                            addressComponent.types.includes("route")
                        )?.long_name,
                        numero: endereco.address_components.find(addressComponent =>
                            addressComponent.types.includes("street_number")
                        )?.long_name,
                        localidade: endereco.address_components.find(addressComponent =>
                            addressComponent.types.includes("administrative_area_level_2")
                        )?.long_name,
                        uf: endereco.address_components.find(addressComponent =>
                            addressComponent.types.includes("administrative_area_level_1")
                        )?.short_name,
                        latitude: endereco.geometry.location.lat().toFixed(7),
                        longitude: endereco.geometry.location.lng().toFixed(7),
                    })
                } else if (response.id || response.logradouro) {
                    // setCepFoiCadastrado(true)
                    response.numero = endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("street_number")
                    )?.long_name
                    setEnderecoCadastrado({
                        ...response,
                        logradouro: endereco.address_components.find(addressComponent =>
                            addressComponent.types.includes("route")
                        )?.long_name,
                        bairroEspecifico: false,
                        latitude: endereco.geometry.location.lat().toFixed(7),
                        longitude: endereco.geometry.location.lng().toFixed(7),
                    })
                } else {
                    alertStart("Não foi possível identificar seu CEP", "error")
                }
            } else {
                setEnderecoCadastrado({
                    logradouro: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("route")
                    )?.long_name,
                    numero: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("street_number")
                    )?.long_name,
                    bairro: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("sublocality_level_1")
                    )?.long_name,
                    localidade: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("administrative_area_level_2")
                    )?.long_name,
                    uf: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("administrative_area_level_1")
                    )?.short_name,
                    bairroEspecifico: aplicativoDados.tipoEntregaBairro === 1,
                    cep: valorCep,
                    latitude: endereco.geometry.location.lat(),
                    longitude: endereco.geometry.location.lng(),
                })
            }
            setAbrirNovoEndereco(true)
            setAbrirCEP(false)
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "checarCepGoogleMaps", endereco)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
            setLoading(false)
        }
    }

    useEffect(() => {
        if (abrirCEP) {
            if (usarGoogleMapsAPI) {
                loader.load().then(google => {
                    let inputBox

                    const temCoordenada =
                        Number(estabelecimentoAtual.latitude) &&
                        Number(estabelecimentoAtual.longitude)

                    const mapCenter = temCoordenada
                        ? {
                              lat: Number(estabelecimentoAtual.latitude),
                              lng: Number(estabelecimentoAtual.longitude),
                          }
                        : { lat: -12.720151, lng: -50.43879 }

                    const mapElement = googleMapRef.current
                    const map = new google.maps.Map(mapElement, {
                        center: mapCenter,
                        zoom: temCoordenada ? 14 : 4,
                    })

                    google.maps.importLibrary("places").then(googlePlacesLibrary => {
                        const input = document.getElementById("search-input")

                        const codigoPais = parametros.PUBLIC_CODIGO_PAIS ?? "br"

                        const options = {
                            bounds: temCoordenada
                                ? {
                                      north: mapCenter.lat + 0.2,
                                      south: mapCenter.lat - 0.2,
                                      east: mapCenter.lng + 0.2,
                                      west: mapCenter.lng - 0.2,
                                  }
                                : { east: 180, west: -180, north: 90, south: -90 }, // Todo o mapa
                            strictBounds: false, // Limita os resultados para dentro de bounds. Se desativado somente dá preferência para eles.
                            fields: ["formatted_address", "geometry", "address_components"],
                            componentRestrictions: { country: codigoPais },
                        }

                        if (temCoordenada) {
                            new google.maps.Marker({
                                position: { lat: mapCenter.lat, lng: mapCenter.lng },
                                map,
                                title: estabelecimentoAtual.nome,
                            })
                        }
                        inputBox = new googlePlacesLibrary.Autocomplete(input, options)

                        const handleAdressSelection = () => {
                            placeRef.current = inputBox.getPlace()

                            if (!placeRef.current.geometry) return

                            if (placeRef.current.geometry.viewport) {
                                map.fitBounds(placeRef.current.geometry.viewport)
                            } else {
                                map.setCenter(placeRef.current.geometry.location)
                                map.setZoom(16)
                            }

                            markerRef.current?.setMap(null)

                            markerRef.current = new google.maps.Marker({
                                position: placeRef.current.geometry.location,
                                map,
                                title: placeRef.current.formatted_address,
                            })
                        }

                        listenerRef.current = inputBox.addListener(
                            "place_changed",
                            handleAdressSelection
                        )
                    })
                })
            }
        }

        return () => listenerRef.current?.remove()
    }, [abrirCEP, googleMapRef.current])

    const [addressInputText, setAddressInputText] = useState("")
    const [selectedFeature, setSelectedFeature] = useState("")
    const [featureOptions, setFeatureOptions] = useState([])

    const handleChangeFeature = e => setSelectedFeature(e.target.value)

    const [openConfirmationMap, setOpenConfirmationMap] = useState(false)
    const handleCloseConfirmationMap = () => setOpenConfirmationMap(false)

    const handleAddressSearch = e => setAddressInputText(e.target.value)

    const handleRetrieve = async () => {
        try {
            const temCoordenada =
                Number(estabelecimentoAtual.latitude) && Number(estabelecimentoAtual.longitude)

            const mapCenter = temCoordenada
                ? {
                      lat: Number(estabelecimentoAtual.latitude),
                      lng: Number(estabelecimentoAtual.longitude),
                  }
                : null

            const customParams = JSON.parse(localStorage.getItem("custom-params") ?? "{}")
            const codigoPais = customParams?.PUBLIC_CODIGO_PAIS ?? "br"
            const codigoLingua = customParams?.PUBLIC_CODIGO_LINGUA ?? "pt"

            let searchString = `https://api.mapbox.com/geocoding/v5/mapbox.places/${addressInputText}.json?access_token=${keyMapBox}&country=${codigoPais.toUpperCase()}&language=${codigoLingua}`

            if (mapCenter) {
                const minLng = mapCenter.lng - 0.15
                const minLat = mapCenter.lat - 0.12
                const maxLng = mapCenter.lng + 0.15
                const maxLat = mapCenter.lat + 0.12

                searchString = searchString
                    .concat(`&proximity=${mapCenter.lng},${mapCenter.lat}`)
                    .concat(`&bbox=${minLng},${minLat},${maxLng},${maxLat}`)
            }

            const res = await api.get(searchString)

            const features = res.data.features

            if (!features.length) {
                alertStart(textos.alertas.nenhumResultadoEndereco, "warning")
                return
            }

            setFeatureOptions(res.data.features)
            const feature = res.data.features[0]
            setSelectedFeature(feature)
            setOpenConfirmationMap(true)

            const fullAddress = feature.place_name.replace("Brazil", "Brasil")
            setAddressInputText(fullAddress)
        } catch (error) {
            console.error()
            RegistrarLogErro(error, "handleRetrieve")
        }
    }

    const handleSaveMarkerLocation = coordinates =>
        setSelectedFeature(prev => ({
            ...prev,
            geometry: {
                ...prev.geometry,
                coordinates,
            },
        }))

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const digitandoCep = async e => {
        try {
            let valorInput = e.target.value
            valorInput = valorInput.replace(/-/g, "")
            valorInput = valorInput.replace(/ /g, "")
            valorInput = valorInput.replace(/\//g, "")

            if (valorInput.length == 8) {
                setAbrirNovoEndereco(true)
                setAbrirCEP(false)
                setLoading(true)
                const response = await ComumCep(valorInput, aplicativoDados)
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                } else {
                    if (response.id || response.logradouro) {
                        setEnderecoCadastrado(response)
                    } else if (response.bairroEspecifico || response.bairros?.length >= 1) {
                        setEnderecoCadastrado(response)
                    } else {
                        alertStart("Não foi possível identificar seu CEP", "error")
                    }
                }
                setLoading(false)
            }
        } catch (error) {
            RegistrarLogErro(error, "digitandoCep", e.target.value)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
            setLoading(false)
        }
    }

    const checarCepMapBox = async () => {
        try {
            let valorCep = selectedFeature.context
                .find(ac => ac.id.includes("postcode"))
                ?.text.replace(/-/g, "")
                .replace(/ /g, "")
                .replace(/\//g, "")

            if (valorCep?.length === 8) {
                setLoading(true)
                const response = await ComumCep(valorCep, aplicativoDados)

                if (response.retornoErro) {
                    setLoading(false)
                    alertStart(response.mensagem, "error")
                    return
                }

                if (response.bairroEspecifico || response.bairros?.length >= 1) {
                    setEnderecoCadastrado({
                        ...response,
                        bairroEspecifico: true,
                        cep: valorCep,
                        logradouro: selectedFeature.text,
                        numero: selectedFeature.address,
                        localidade: selectedFeature.context.find(ac => ac.id.includes("place"))
                            ?.text,
                        uf: selectedFeature.context
                            .find(ac => ac.id.includes("region"))
                            ?.short_code?.split("-")[1],
                        latitude: selectedFeature.center[1].toFixed(7),
                        longitude: selectedFeature.center[0].toFixed(7),
                    })
                } else if (response.id || response.logradouro) {
                    // setCepFoiCadastrado(true)
                    response.numero = selectedFeature.address
                    setEnderecoCadastrado({
                        ...response,
                        bairroEspecifico: false,
                        logradouro: selectedFeature.text,
                        latitude: selectedFeature.center[1].toFixed(7),
                        longitude: selectedFeature.center[0].toFixed(7),
                    })
                } else {
                    alertStart("Não foi possível identificar seu CEP", "error")
                }
            } else {
                setEnderecoCadastrado({
                    bairroEspecifico: aplicativoDados.tipoEntregaBairro === 1,
                    cep: valorCep,
                    logradouro: selectedFeature.text,
                    numero: selectedFeature.address,
                    bairro: selectedFeature.context.find(ac => ac.id.includes("neighborhood"))
                        ?.text,
                    localidade: selectedFeature.context.find(ac => ac.id.includes("place"))?.text,
                    uf: selectedFeature.context
                        .find(ac => ac.id.includes("region"))
                        ?.short_code?.split("-")[1],
                    latitude: selectedFeature.center[1].toFixed(7),
                    longitude: selectedFeature.center[0].toFixed(7),
                })
            }
            setAbrirNovoEndereco(true)
            setAbrirCEP(false)
            handleCloseConfirmationMap()
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "checarCepMapBox", selectedFeature)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
            setLoading(false)
        }
    }

    const handleRetiradaNoLocal = () => {
        selecioneiRetiradaNoLocal()
        setAbrirCEP(false)
        DialogFormaDePagamento(false)
        DialogConfirmacaoinformacoes(true)
    }

    const handleClose = () => {
        setAbrirCEP(false)
        setAddressInputText("")
    }

    const handleSubmit = e => {
        e.preventDefault()
        if (usarMapBoxAPI) handleRetrieve()
        else if (usarGoogleMapsAPI) {
            if (!placeRef.current) {
                alertStart(textos.digiteEndereco, "warning")
                return
            }
            checarCepGoogleMaps(placeRef.current)
            setAbrirNovoEndereco(true)
            setAbrirCEP(false)
            setLoading(true)
        }
    }

    return (
        <>
            <Dialog
                open={abrirCEP}
                aria-labelledby="cep-title"
                fullWidth={true}
                maxWidth="md"
                onClose={handleClose}
            >
                {!fullScreen ? <img src={aplicativoDados.urlLogo} className="imgModal" /> : null}

                <DialogTitle id="cep-title">
                    <IconButton className="setaVoltarModal" onClick={handleClose}>
                        <ArrowForwardIosIcon />
                    </IconButton>
                    {textos.adicionarEndereco}
                </DialogTitle>

                <form onSubmit={handleSubmit}>
                    <DialogContent className={classes.dialogContent}>
                        <Typography gutterBottom align="center" variant="h5" component="p">
                            {usarAlgumMapa ? textos.digiteEndereco : textos.digiteCep}
                        </Typography>
                        {usarMapBoxAPI ? (
                            <div className={classes.contentContainer}>
                                <TextField
                                    value={addressInputText}
                                    onChange={handleAddressSearch}
                                    autoFocus
                                    fullWidth
                                    variant="outlined"
                                    placeholder={textos.digiteEndereco}
                                    helperText={textos.enderecoHelperText}
                                />
                                <div className={classes.buttonContainer}>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        onClick={handleRetiradaNoLocal}
                                    >
                                        {textos.retirarNoLocal}
                                    </Button>
                                    <Button
                                        type="submit"
                                        className={classes.confirmarButton}
                                        variant="contained"
                                        disabled={false}
                                    >
                                        {textos.continuar}
                                    </Button>
                                </div>
                            </div>
                        ) : usarGoogleMapsAPI ? (
                            <div className={classes.contentContainer}>
                                <TextField
                                    id="search-input"
                                    autoFocus
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    placeholder={textos.digiteEndereco}
                                />
                                <div className={classes.googleMapsContainer}>
                                    <div ref={googleMapRef} />
                                </div>
                                <div className={classes.buttonContainer}>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        onClick={handleRetiradaNoLocal}
                                    >
                                        {textos.retirarNoLocal}
                                    </Button>
                                    <Button
                                        type="submit"
                                        className={classes.confirmarButton}
                                        variant="contained"
                                    >
                                        {textos.confirmar}
                                    </Button>
                                </div>
                            </div>
                        ) : (
                            <>
                                <TextField
                                    type="text"
                                    autoFocus
                                    fullWidth
                                    required
                                    name="CEP"
                                    id="cepDigitando"
                                    label="CEP"
                                    variant="outlined"
                                    onChange={digitandoCep}
                                    style={{ margin: "10px 0 5px 0" }}
                                />
                                <Button
                                    type="button"
                                    variant="contained"
                                    onClick={() => {
                                        setEnderecoCadastrado({})
                                        setAbrirNovoEndereco(true)
                                        setAbrirCEP(false)
                                        setLoading(true)
                                    }}
                                    color="default"
                                    style={{ margin: "15px 0 35px 0" }}
                                >
                                    Não Sei CEP
                                </Button>
                            </>
                        )}
                    </DialogContent>
                </form>
            </Dialog>
            <DialogConfirmationMapBox
                openConfirmationMap={openConfirmationMap}
                handleCloseConfirmationMap={handleCloseConfirmationMap}
                featureOptions={featureOptions}
                selectedFeature={selectedFeature}
                handleChangeFeature={handleChangeFeature}
                handleSaveMarkerLocation={handleSaveMarkerLocation}
                checarCepMapBox={checarCepMapBox}
            />
        </>
    )
}
